export enum RankedGeographyTypesEnum {
    city = 0,
    county = 1,
    province = 2,
    country = 3,
    continent = 4
}
